import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Section,
  Inner,
  Grid,
  Card,
  CardTitle,
  ImgWrap,
  Img,
  DecorativeLine,
  BottomText,
  Header,
  Title,
  Subtitle,
} from "./OurProductsSectionStyles";

import cake1 from "../../assets/Tort_emeraude_fistic_zmeura_slice_.jpg";
import cake2 from "../../assets/CarouselHome/10.png";
import cake3 from "../../assets/Tort_Macarons_Cadou.jpg";

export default function OurProductsSection({
  title,
  subtitle,
  cards = [
    {
      title: "Torturi spectaculoase",
      image: cake1,
      categoryId: "torturi",
    },
    {
      title: "Prăjituri fine",
      image: cake2,
      categoryId: "prajituri_artizanale",
    },
    {
      title: "Desert personalizat",
      image: cake3,
      categoryId: "cadouri_dulci",
    },
  ],
  description,
}) {
  const navigate = useNavigate();

  const handleCardClick = (categoryId) => {
    if (!categoryId) {
      navigate("/");
      return;
    }

    navigate("/", {
      state: { targetCategoryId: categoryId },
    });
  };

  return (
    <Section>
      <Header>
        {title && <Title>{title}</Title>}
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </Header>

      <Inner>
        <Grid>
          {cards.map((c, i) => (
            <Card
              key={i}
              onClick={() => handleCardClick(c.categoryId)}
              style={{ cursor: "pointer" }}
            >
              <CardTitle>{c.title}</CardTitle>
              <ImgWrap>
                <Img src={c.image} alt={c.title} loading="lazy" />
              </ImgWrap>
            </Card>
          ))}
        </Grid>

        <DecorativeLine />
        <BottomText>{description}</BottomText>
      </Inner>
    </Section>
  );
}
